import Reflux from "reflux";

export const VersionActions = {
  get: Reflux.createAction()
};
